import React from 'react';

import ResourceType from '../../../utils/resource-types';
import DigestCategories from '../../../utils/digest-categories';
import Accordion from '../../accordion/accordion';
import ListWrapper from './list-wrapper';
import ConfirmationModal from '../../confirmation-modal/confirmation-modal';
import ItemModal from '../../item-modal/item-modal';
import VideoModal from './video-modal';
import AudioModal from './audio-modal';
import { isActivity } from '../../../utils/tcc-utils';
import ContentTypes from '../../../utils/content-types';
import activityContentTypes from '../../../utils/activity-content-types';

export default class ItemList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            onConfirm: null,
            subItem: null,
            onConfirmUpdate: null,
        };
    }

    updateNestedItem = (key, value) => {
        const { card, name } = this.props;
        this.props.updateNestedItem(name, { ...card, [key]: value });
    };

    updateNestedArray = (index, value) => {
        const items = [...this.props.card.items];
        value !== undefined ? items[index] = value : items.splice(index, 1);
        this.updateNestedItem('items', items);
    };

    addNewItem = () => {
        this.updateNestedArray(this.props.card.items.length, ContentTypes.ITEMS.build());
    };

    render() {
        const { card, links, isActivity } = this.props;

        return (
            <ListWrapper
                {...card} links={links} isActivity={isActivity}
                updateNestedItem={this.updateNestedItem}
                addNewItem={this.addNewItem}
            >
                <ItemListAccordion {...this.props} updateNestedArray={this.updateNestedArray} />
            </ListWrapper>
        );
    }
}

class ItemListAccordion extends React.Component {

    state = {
        onConfirm: null,
        subItem: null,
        onConfirmUpdate: null,
    };

    render() {
        const { card } = this.props;
        const items = card.items
            .map((item, itemIndex) => {
                const updateItem = this.props.updateNestedArray;
                const updateSubItem = (index, subItem) => {
                    const subItems = updatedItem(item.items)(index, subItem);
                    updateItem(itemIndex, updatedItem(item)('items', subItems));
                };
                const value = this.editableItem(item, itemIndex, updateItem);
                const subItems = item.items
                    .map((subItem, subItemIndex) => this.editableSubItem(
                        subItem,
                        subItemIndex,
                        updateSubItem,
                    ));
                subItems.push(
                    <div
                        onClick={() => this.setState({
                            subItem: { title: '' },
                            hasActivity: item.items.filter(i => i.type === ResourceType.ACTIVITY).length !== 0,
                            onConfirmUpdate: (value) => updateSubItem(item.items.length, value),
                        })}
                        className='add-icon'
                    >
                        <i className='fa fa-plus-circle' title='Adicionar item'/>
                    </div>
                );
                return { ...item, value, items: subItems };
            });

        return (
            <React.Fragment>
                <div className='section-accordion'>
                    <Accordion sections={items}/>
                </div>
                {this.state.onConfirm &&
                <ConfirmationModal
                    show={true}
                    onClose={() => this.setState({ onConfirm: null })}
                    onConfirm={this.state.onConfirm}
                />
                }
                {this.state.onConfirmUpdate &&
                <ItemModal
                    item={this.state.subItem}
                    hasActivity={this.state.hasActivity}
                    show={true}
                    onClose={() => this.setState({ onConfirmUpdate: null })}
                    updateSectionItem={this.state.onConfirmUpdate}
                />
                }
            </React.Fragment>
        );
    }

    editableItem = (item, itemIndex, updateItem) => {
        return (
            <React.Fragment>
                {isActivity(item) && <span>{itemIndex + 1}.</span>}
                <input
                    className='accordion-input'
                    onClick={(e) => e.stopPropagation()}
                    name='title'
                    value={item.title}
                    onChange={(e) => updateItem(itemIndex, updatedItem(item)(e.target.name, e.target.value))}
                />
                <div
                    onClick={(e) => {
                        this.setState({ onConfirm: () => updateItem(itemIndex, undefined) });
                        e.stopPropagation();
                    }} className='section-trash'
                >
                    <i className='fa fa-trash' title='Deletar item'/>
                </div>
            </React.Fragment>
        );
    };

    editableSubItem = (subItem, subItemIndex, updateSubItem) => {
        return (
            <React.Fragment>
                {this.renderSubItem(subItem)}
                <div className='item-icons'>
                    <div onClick={() => this.setState({
                        subItem,
                        onConfirmUpdate: (value) => updateSubItem(subItemIndex, value),
                    })} className='edit'>
                        <i className='fa fa-pencil' title='Editar item'/>
                    </div>
                    <div onClick={() => this.setState({ onConfirm: () => updateSubItem(subItemIndex, undefined) })}
                        className='trash'>
                        <i className='fa fa-trash' title='Deletar item'/>
                    </div>
                </div>
            </React.Fragment>
        );
    };

    renderSubItem = (item) => {
        switch (item.type) {
        case ResourceType.DIGEST:
            return <DigestContentSubItem {...item}/>;

        case ResourceType.VIDEO:
            return <VideoContentSubItem {...item}/>;

        case ResourceType.AUDIO:
            return <AudioContentSubItem {...item}/>;

        case ResourceType.ACTIVITY:
            return <ActivityContentSubItem contentType={item.activityContentType}/>;

        case ResourceType.LIVE_LESSON:
            return <LiveLessonContentSubItem {...item}/>;

        default:
            return <LinkContentSubItem {...item}/>;
        }
    };
}

class VideoContentSubItem extends React.Component {

    state = {
        video: null,
    };

    render() {
        const { url, title, type, text = '' } = this.props;
        const { video } = this.state;

        return (
            <div className='flex-vertical'>
                <div onClick={() => this.setState({ video: url })} style={{ cursor: 'pointer' }}>
                    <div className='item-wrapper new-video'>
                        <div className='type-icon'><i className={icons[type]}/></div>
                        <div>{title}</div>
                    </div>
                </div>
                <div className='important-text'>
                    {text && (text || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
                </div>
                {video && <VideoModal
                    videoUrl={video}
                    onClose={() => this.setState({ video: null })}
                />}
            </div>
        );
    }
}

class AudioContentSubItem extends React.Component {

    state = {
        audio: null,
    };

    render() {
        const { url, title, type, text = '' } = this.props;
        const { audio } = this.state;

        return (
            <div className='flex-vertical'>
                <div onClick={() => this.setState({ audio: url })} style={{ cursor: 'pointer' }}>
                    <div className='item-wrapper'>
                        <div className='type-icon'><i className={icons[type]}/></div>
                        <div>{title}</div>
                    </div>
                </div>
                <div className='important-text'>
                    {text && (text || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
                </div>
                {audio &&
                <AudioModal
                    playerUrl={audio}
                    onClose={() => this.setState({ audio: null })}
                />}
            </div>
        );
    }
}

const DigestContentSubItem = ({ category, title, text }) => (
    <div className='important-item'>
        <p className='important-title'>
            <i className={`important-icon ${icons[category]}`}/>{title}
        </p>
        <div className='important-text'>
            {(text || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
        </div>
    </div>
);

const LinkContentSubItem = ({ url, title, type, text = '' }) => (
    <div className='flex-vertical'>
        <a href={url} download={type !== ResourceType.LINK} target='_blank'>
            <div className='item-wrapper'>
                <div className='type-icon'><i className={icons[type]}/></div>
                <div>{title}</div>
            </div>
        </a>
        <div className='important-text'>
            {text && (text || '').split('\n').map((p, i) => <p key={i}>{p}</p>)}
        </div>
    </div>
);

const ActivityContentSubItem = ({ contentType }) => {
    const showTextArea = [activityContentTypes.JUST_TEXT, activityContentTypes.TEXT_AND_ATTACHMENT, activityContentTypes.SMALL_TEXT]
        .includes(contentType);

    const showAttachments = contentType === activityContentTypes.JUST_ATTACHMENT || contentType === activityContentTypes.TEXT_AND_ATTACHMENT;
    return (
        <React.Fragment>
            <div className='activity-content'>
                {showTextArea &&
                    <div className='learning-item'>
                        <textarea value='' disabled />
                    </div>
                }
                {showAttachments &&
                    <div className='attachments-indicator'>
                        <span>Essa atividade suporta anexos</span>
                    </div>
                }
            </div>
        </React.Fragment>
    );
};

const LiveLessonContentSubItem = ({ url, title, type }) => (
    <div className='flex-vertical'>
        <a href={url} target='_blank'>
            <div className='item-wrapper'>
                <div className='type-icon'><i className={icons[type]}/></div>
                <div>{title}</div>
            </div>
        </a>
    </div>
);

const icons = {
    [ResourceType.VIDEO]: 'fa fa-video-camera',
    [ResourceType.AUDIO]: 'fa fa-music',
    [ResourceType.FILE]: 'fa fa-file-text',
    [ResourceType.LINK]: 'fa fa-external-link',
    [ResourceType.LIVE_LESSON]: 'fa fa-television',
    [DigestCategories.BOOK]: 'fa fa-bookmark',
    [DigestCategories.MOVIE]: 'fa fa-film',
    [DigestCategories.ROUTINE]: 'fa fa-calendar',
    [DigestCategories.DYNAMIC]: 'fa fa-check',
    [DigestCategories.QUESTION]: 'fa fa-question-circle',
};

const updatedItem = (initialValue) => (key, value) => {
    if (Array.isArray(initialValue)) {
        const newValue = [...initialValue];
        value !== undefined ? newValue[key] = value : newValue.splice(key, 1);
        return newValue;
    }
    return { ...initialValue, [key]: value };
};



// WEBPACK FOOTER //
// ./src/components/section/components/item-list.js